export default {

    //**********BASE DE DATOS ***************************************************/
    //Con este script, das de alta la opción y se le otorgan permisos a roles de nivel 1. El 1 al final indica que la opción debe ser validada.
    //parametros :  229= modulo, 11 = menuid, 4 es el id(emopieza en el numero 1), 'Eliminar' = nombre, ''= en vacio, 'Eliminar.png' = foto, 1 = valida aceso
    //Exec VerificaMenuOpciones 229, 11, 4, 'Eliminar', '', 'Eliminar.png',  1
    
    
    //para obtener un script que extrae opciones de menu (Menu + Opciones), puedes ejecutar esto:
    //exec Verificacion_General_Menu_Opciones 229
    //************************************************************************* */
     
    //opciones de menu 

    TOpciones_Menu: {
        Nuevo: { value: 'Nuevo', label:'Nuevo' },
        Editar: { value: 'Editar', label:'Editar' },
        Eliminar: { value: 'Eliminar', label:'Eliminar' },
        Imprimir: { value: 'Imprimir', label:'Imprimir' },
        Guardar: { value: 'Guardar', label:'Guardar' },
        Buscar: { value: 'Buscar', label:'Buscar' },
        Procesar: { value: 'Procesar', label:'Procesar' },
        Refrescar: { value: 'Refrescar', label:'Refrescar' },
        Aplicar: { value: 'Aplicar', label:'Aplicar' },
        Generar: { value: 'Generar', label:'Generar' },
        Enviar: { value: 'Enviar', label:'Enviar' },
        Cargar: { value: 'Cargar', label:'Cargar' },
        Inactivar:{ value: 'Inactivar', label:'Inactivar'},
        VerDetalle:{value:'VerDetalle',label:'VerDetalle'},
        Anular: { value: 'Anular', label:'Anular' },
        Liquidar:{value:'Liquidar', label:'Liquidar'},
        Exportar:{value:'Exportar', label:'Exportar'},
        Aprobar:{value:'Aprobar', label:'Aprobar'},
        Rechazar: { value: 'Rechazar', label: 'Rechazar' },
        Plantilla: { value: 'Plantilla', label: 'Plantilla' },
        Digitar:{value:'Digitar', label:'Digitar'},
        Reversar: { value: 'Reversar', label: 'Reversar' },
        MoverAlMes: { value: 'MoverAlMes', label: 'MoverAlMes' },
        Desbloquear: { value: 'Desbloquear', label: 'Desbloquear' },
        ImportarExcel: { value: 'ImportarExcel', label: 'ImportarExcel' },
        Importar: { value: 'Importar', label: 'Importar' },
        Reasignar:{value: 'Reasignar', label:'Reasignar'},
        NuevoMasivo: { value: 'Nuevo Masivo', label:'Nuevo Masivo' },
        GuardarCentroCosto:{value:'Guardar Centro Costo', label:'Guardar Centro Costo'},
        EstadoCentroCosto:{value:'Estado Centro Costo', label:'Estado Centro Costo'},
        EliminarCentroCosto:{value:'Eliminar Centro Costo', label:'Eliminar Centro Costo'},
    },



    //   menu del sistema
    //Select replace(replace(replace(replace(replace(replace(replace(Menu_Nombre, ' ', ''),'á','a'),'é','e'),'í','i'),'ó','o'),'ú','u'),'ñ','n') + ':{value:"' + Menu_Nombre + '"},' from seg_menu where modulo_id = xxx
    TMenuSistema: {        
        Archivo:{value:"Archivo"},
        Asientos:{value:"Asientos"},
        Procesos:{value:"Procesos"},
        Reportes:{value:"Reportes"},
        ll:{value:"ll"},
        Corporacion:{value:"Corporación"},
        AbrirEmpresa:{value:"Abrir Empresa"},
        Parametros:{value:"Parámetros"},
        TiposdeCuentas:{value:"Tipos de Cuentas"},
        CatalogodeCuentas:{value:"Catálogo de Cuentas"},
        CatalogodeCentrodeCosto:{value:"Catálogo de Centro de Costo"},
        TiposdeAsientos:{value:"Tipos de Asientos"},
        EtiquetasdeReportes:{value:"Etiquetas de Reportes"},
        ReasignacionCatalogo:{value:"Reasignación Catálogo"},
        ReasignacionCentroCosto:{value:"Reasignación Centro Costo"},
        ImportarCatalogo:{value:"Importar Catálogo"},
        ImportarTiposdeAsiento:{value:"Importar Tipos de Asiento"},
        Plantillas:{value:"Plantillas"},
        Digitar:{value:"Digitar"},
        Aprobar:{value:"Aprobar"},
        Aplicar:{value:"Aplicar"},
        Anular:{value:"Anular"},
        DesbloquearAsiento:{value:"Desbloquear Asiento"},
        ImportacionAsientos:{value:"Importación Asientos"},
        CierreMensual:{value:"Cierre Mensual"},
        CierreAnual:{value:"Cierre Anual"},
        CentrosdeCosto:{value:"Centros de Costo"},
        CentrosdeUtilidad:{value:"Centros de Utilidad"},
        Presupuesto:{value:"Presupuesto"},
        ConciliaciondeAuxiliares:{value:"Conciliación de Auxiliares"},
        CargaAsientoExcel:{value:"Carga Asiento Excel"},
        AsientosdeDiario:{value:"Asientos de Diario"},
        DiarioGeneral:{value:"Diario General"},
        EstadodeResultadosFinanciero:{value:"Estado de Resultados Financiero"},
        EstadodeResultadosFiscal:{value:"Estado de Resultados Fiscal"},
        BalancedeSituacion:{value:"Balance de Situación"},
        BalancedeComprobacion:{value:"Balance de Comprobación"},
        BalancedeComprobacionEstimado:{value:"Balance de Comprobación Estimado"},
        HistoricodeSaldos:{value:"Histórico de Saldos"},
        ImpresiondelCatalogo:{value:"Impresión del Catálogo"},
        ImpresiondeCuentas:{value:"Impresión de Cuentas"},
        ImpresiondeCentrodeCosto:{value:"Impresión de Centro de Costo"},
        Movimientossinaplicar:{value:"Movimientos sin aplicar"},
        Comprometido:{value:"Comprometido"},
        ConsolidaciondeCuentas:{value:"Consolidación de Cuentas"},
        CentrosdeCosto:{value:"Centros de Costo"},
        CentrodeUtilidad:{value:"Centro de Utilidad"},
        AsientosdelCierre:{value:"Asientos del Cierre"},
        CierreFiscal:{value:"Cierre Fiscal"},
        ImpresiondeBitacora:{value:"Impresión de Bitácora"},
        Presupuesto:{value:"Presupuesto"},
        EstadodeResultados:{value:"Estado de Resultados"},
        BalancedeSituacion:{value:"Balance de Situación"},
        CentrodeCosto:{value:"Centro de Costo"},
        CentrodeUtilidad:{value:"Centro de Utilidad"},
        Cambiarcontrasena:{value:"Cambiar contraseña"},
        Reportes:{value:"Reportes"}, 
        Salir:{value:"Salir"},
        
    }

};
